<template>
<div>
<b-modal id="modal-sm" size="md" title="Manage Clinics" v-model="showModal" no-close-on-esc no-close-on-backdrop hide-header-close>
    <div slot="default">
        <div class='alert alert-warning' role='alert' v-if=!succeeded> {{Msg}} <br> Please Contact System Administrator. </div>
        <div class="alert alert-success" role="alert" v-if=succeeded> {{Msg}} </div>
    </div> 
    <div slot="modal-footer" class="w-100">
        <p class="float-left" variant="primary"></p>
        <b-button variant="primary"  size="md"  class="float-right BtnClose"  @click="clinicExit"> Close </b-button>
    </div>
</b-modal>
<form>
<div class="form-group row my-1">
    <label for="ClinicName" class="col-sm-4 label-small my-0">Clinic Name:</label>
    <div class="col-sm-4 my-0">
        <input id="ClinicName" :disabled="EditMode=='Edit'  && (this.iseffective && this.isExpired)" type="text" maxlength="50"  placeholder="Clinic Name" v-model="clinicname" class="mb-0 form-control form-control-xs">
    </div>
    <div  class="col-sm-4" v-show="$v.clinicname.$error">
        <div  class="row"  >
            <small class="sml-red" v-if="!$v.clinicname.required">Clinic name is required</small>
        </div> 
    </div>
</div>

<div class="form-group row my-1">
    <label for="ClinicNumber" class="col-sm-4 label-small my-0">Clinic Number:</label>
    <div class="col-sm-4 my-0">
        <input id="ClinicNumber" v-model="clinicno" maxlength="5" :disabled="mode=='Edit'" type="text" placeholder="Clinic Number" class="mb-0 form-control form-control-xs">
    </div>
    <div   class="col-sm-4" v-show="$v.clinicno.$error">
        <div  class="row"  >
            <small class="sml-red" v-if="!$v.clinicno.required">Clinic number is required</small>
            <small class="sml-red" v-if="!$v.clinicno.minLength">Clinic number must have a lenght of 5</small>
            <small class="sml-red" v-if="!$v.clinicno.numeric">Clinic number must be numeric</small>
        </div> 
    </div>
</div>

<div class="form-group row  my-1 mb-0">
    <label for="roles" class="col-sm-4 col-form-label col-form-label-sm">Service Type</label>
    <div class="col-sm-4 my-0">
        <select  id="roles" :disabled="EditMode=='Edit'  && (this.iseffective)" v-model="servicetype"  class="mb-0 form-control form-control-xs"> 
            <option v-for="option in ServiceTypes" v-bind:value="{id: option.id, text: option.text, type:option.type}" :key="option.id">
                {{ option.text }}
            </option> 
        </select>   
    </div>
    <div  class="col-sm-4" v-show="$v.servicetype.$error">
        <div  class="row">
            <small class="sml-red" v-if="!$v.servicetype.required">Service type is required</small>
        </div> 
    </div>
</div>  

<div class="form-group row p-0  no-gutters card-header tile-note" >
   <label for="roles" class="col-sm-4 col-form-label col-form-label-sm ml-2 mt-2"><b>Is Clinic Pending ? <i class="fa fa-spinner fa-spin fa-fw ml-2"></i>
    <span class="sr-only">Loading...</span></b></label>
    <div class="col-sm-4 ml-0 p-0 mt-0"  :class="pointerevent">
              <template 
                ><RadioToggleButtons
                   
                  v-on:change ="pendingChange()" 
                  v-model="pending"
                  :values="PendingValues"
                  color="#006537"
                  textColor="#000"
                  selectedTextColor="#fff"
                   @click=" canClick ? this.iseffective : void 0"
                />
                <!-- <span v-on:click="pending==='true'? effectivedate ='9999/12/31' : effectivedate" style="font-size: 1em;"><i class="fas fa-times ml-2 pointer"></i>  </span> -->
              </template>

    </div>
            <!-- <div  class="col-sm-4" v-show="$v.pending.$error">
                <div class="row">
                <small class="sml-red" v-if="!$v.pending.required">Clinic status is required.</small>
                </div> 
            </div> -->
</div> 

<div class="form-group row my-1 mt-0">
    <label for="ServiceType" class="col-sm-4 label-small">Clinic Manager:</label>
        <div class="col-sm-4 my-0">
        <input id="ClinicManager" :disabled="EditMode=='Edit'  && (this.iseffective && this.isExpired)"  maxlength="50" type="text" v-model="clinicmanager" placeholder="Clinic Manager" class="mb-0 form-control form-control-xs">
    </div>
    <!-- <div  class="col-sm-4" v-show="$v.clinicmanager.$error">
        <div class="row" >
            <small class="sml-red" v-if="!$v.clinicmanager.required">Clinic manager is required</small>
        </div> 
    </div> -->
</div>

<div class="form-group row my-1">
    <label for="PhoneNumber" class="col-sm-4 label-small my-0">Phone:</label>
        <div class="col-sm-4 my-0">
        <input id="PhoneNumber" :disabled="EditMode=='Edit'  && (this.iseffective && this.isExpired)"  type="tel" v-model="businessphoneno" placeholder="Phone Number" class="mb-0 form-control form-control-xs">
    </div>
    <div  class="col-sm-4" v-show="$v.businessphoneno.$error">
    <div class="row" >
        <small class="sml-red" v-if="!$v.businessphoneno.required">Phone number is required</small>
        <small class="sml-red" v-if="!$v.businessphoneno.isPhone">Phone number is invalid</small>
        </div> 
    </div>
</div>
<div class="form-group row my-1">
    <label for="FaxNumber" class="col-sm-4 label-small my-0">Fax:</label>
        <div class="col-sm-4 my-0">
        <input id="FaxNumber" :disabled="EditMode=='Edit'  && (this.iseffective && this.isExpired)"  type="tel" v-model="businessfax" placeholder="Fax Number" class="mb-0 form-control form-control-xs">
    </div>
    <div  class="col-sm-4"  v-show="$v.businessfax.$error">
    <div class="row">
            <small class="sml-red" v-if="!$v.businessfax.isPhone">Fax number is invalid</small>
        </div> 
    </div>
</div> 
<div class="form-group row my-1">
    <label for="EmailAddress" class="col-sm-4 label-small my-0">Email:</label>
        <div class="col-sm-4 my-0">
        <input id="EmailAddress" :disabled="EditMode=='Edit'  && (this.iseffective && this.isExpired)"  maxlength="56" type="email" v-model="emailaddress" placeholder="Email Address" class="mb-0 form-control form-control-xs">
    </div>
    <div  class="col-sm-4" v-show="$v.emailaddress.$error">
    <div class="row" >
        <!-- <small class="sml-red" v-if="!$v.emailaddress.required">Email is required</small> -->
        <small class="sml-red" v-if="!$v.emailaddress.email">Email is invalid</small>
        </div> 
    </div>
</div>
<!-- pending  = {{this.pending}}
required = {{!$v.address1.required}}
error  = {{$v.address1.$error}}
address = {{address1}} -->
<div class="form-group row my-1">
    <label for="Address1" class="col-sm-4 label-small my-0">Address:</label>
    <div class="col-sm-4 my-0">
        <input id="Address1" type="text" :disabled="EditMode=='Edit'  && (this.iseffective && this.isExpired)"  maxlength="45" v-model="address1" placeholder="Address" class="mb-0 form-control form-control-xs">
    </div>
    <!-- <div  class="col-sm-4" v-show="$v.address1.$error"> -->
     <div  class="col-sm-4" v-show="$v.address1.$error">
        <div class="row" >
            <small class="sml-red" v-if="!$v.address1.required">Address is required</small>
        </div> 
    </div>
</div>

<div class="form-group row my-1">
    <label for="Address2" class="col-sm-4 label-small my-0">Apt/Po-Box:</label>
        <div class="col-sm-4 my-0">
        <input id="Address2" type="text" :disabled="EditMode=='Edit'  && (this.iseffective && this.isExpired)"  maxlength="25" v-model="address2" placeholder="Apt or Po-Box" class="mb-0 form-control form-control-xs">
    </div> 
</div>   

<div class="form-group row my-1">
    <label for="Address3" class="col-sm-4 label-small my-0">City:</label>
        <div class="col-sm-4 my-0">
        <input id="Address3" type="text" :disabled="EditMode=='Edit'  && (this.iseffective && this.isExpired)"  maxlength="25" v-model="address3" placeholder="City" class="mb-0 form-control form-control-xs">
    </div>
    <div class="col-sm-4"  v-show="$v.address3.$error">
        <div class="row">
            <small class="sml-red" v-if="!$v.address3.required">City is required</small>
        </div>
    </div>
</div>    



<div class="form-group row my-1">
    <label for="Province" class="col-sm-4 label-small my-0">Province:</label>
    <div class="col-sm-4 my-0">
        <select  id="prov" :disabled="EditMode=='Edit'  && (this.iseffective && this.isExpired)"  v-model="provincecode"  class="mb-0 form-control form-control-xs"> 
        <option v-for="option in Prov" v-bind:text="{text: option}" :key="option">
        {{ option}}
        </option> 
        </select> 
    </div>
</div>

<div class="form-group row my-1">
    <label for="PostalCode" class="col-sm-4 label-small my-0">Postal Code:</label>
    <div class="col-sm-4 my-0">
        <input id="PostalCode" :disabled="EditMode=='Edit'  && (this.iseffective && this.isExpired)"  v-model="postalcode" placeholder="Postal Code" class="mb-0 form-control form-control-xs">
    </div>
    <div  class="col-sm-4"  v-show="$v.postalcode.$error">
    <div class="row">
            <small class="sml-red" v-if="!$v.postalcode.isPostal">Postal code is invalid</small>
            <small class="sml-red" v-if="!$v.postalcode.required">Postal code is required</small>
        </div> 
    </div>
</div> 


<div class="form-group row my-1">
    <label for="EffectiveDate" class="col-sm-4 label-small my-0">Effective Date:</label>
    <div class="col-sm-4 my-0">
        <!-- <datepicker :disabled="EditMode=='Edit'  && (this.iseffective)" typeable :open-date="new Date()" :disabledDates="{ to: new Date(Date.now() - 8640000) }" v-model="effectivedate" :format="dateFormat" id="effDate" :bootstrap-styling="true" :input-class="datapickClass" name="effectiveDatepicker"></datepicker> -->
        <!-- <datepicker :disabled="(this.iseffective) &&  this.EditMode !== 'Add'" typeable :open-date="new Date()" :disabledDates="{ to: new Date(Date.now() - 8640000) }" v-model="effectivedate" :format="dateFormat" id="effDate" :bootstrap-styling="true" :input-class="datapickClass" name="effectiveDatepicker"></datepicker>   -->
            <datepicker :disabled="((this.iseffective) &&  this.EditMode !== 'Add') ||  this.pending === 'true' " typeable      v-model="effectivedate" :format="dateFormat" id="effDate" :bootstrap-styling="true" :input-class="datapickClass" name="effectiveDatepicker"></datepicker>  
    </div>
    <div  class="col-sm-4" v-show="$v.expirydate.$error">
        <div class="row">
            <small class="sml-red" v-if="!$v.effectivedate.required">Effective date is required</small>
        </div> 
    </div>
</div>

<div class="form-group row my-1">
    <label for="ExpiryDate" class="col-sm-4 label-small my-0">Expiry Date:</label>
    <div class="col-sm-4 my-0">
        <datepicker typeable :open-date="new Date()" :disabled="EditMode=='Edit'  && (this.iseffective && this.isExpired)" :disabledDates="{ to: new Date(Date.now() - 8640000) }" v-model="expirydate" :format="dateFormat" id="effDate" :bootstrap-styling="true" :input-class="datapickClass" name="expirydatepicker"></datepicker> 
    </div>
    <div  class="col-sm-4" v-show="$v.expirydate.$error">
    <div class="row">
            <small class="sml-red" v-if="!$v.expirydate.required">Expiry date is required</small>
        <small class="sml-red" v-if="!$v.expirydate.minValue1 && $v.expirydate.required">Expiry Date can't be in the past</small>
        <small class="sml-red" v-if="!$v.expirydate.minValue2 && $v.expirydate.required">Expiry Date must be greater than the effective date</small>
        </div> 
    </div>
</div> 

<div class="form-group row my-1">
    <label for="MidasSupplier" class="col-sm-4 label-small my-0">Midas Supplier:</label>
    <div class="col-sm-4 my-0">
        <input id="MidasSupplier"  :disabled="EditMode=='Edit'  && (this.iseffective && this.isExpired)" maxlength="30" type="tel" v-model="midassupplierno" placeholder="Midas Supplier" class="mb-0 form-control form-control-xs">
    </div>
    <div  class="col-sm-4" v-show="$v.midassupplierno.$error">
    <div class="row">
            <small class="sml-red" v-if="!$v.midassupplierno.required">Midas supplier is invalid</small>
            <small class="sml-red" v-if="!$v.midassupplierno.numeric">Must be numeric</small>
        </div> 
    </div>
</div>  

<div class="form-group row my-1">
    <label for="MidasSupplierSite" class="col-sm-4 label-small my-0">Midas Supplier Site:</label>
    <div class="col-sm-4 my-0">
        <input id="MidasSupplierSite" :disabled="EditMode=='Edit'  && (this.iseffective && this.isExpired)" maxlength="15" type="tel" v-model="midassuppliersite" placeholder="Midas Supplier Site" class="mb-0 form-control form-control-xs">
    </div>
    <div  class="col-sm-4" v-show="$v.midassuppliersite.$error">
    <div class="row">
            <small class="sml-red" v-if="!$v.midassuppliersite.required">Midas supplier site is required</small>
            <small class="sml-red" v-if="!$v.midassuppliersite.alphaNum">Must be a valid site</small>
        </div> 
    </div>
</div>

<div class="form-group row  my-1">
    <label for="roles" class="col-sm-4 col-form-label col-form-label-sm">Midas Payment Method:</label>
    <div class="col-sm-4">
        <select  id="roles" :disabled="EditMode=='Edit'  && (this.iseffective && this.isExpired)" v-model="codepayment"  class="form-control form-control-xs"> 
            <option v-for="option in PayType" v-bind:value="{id: option.id, text: option.text}" :key="option.id">
                {{ option.text }}
            </option> 
        </select> 

    </div>
        <div  class="col-sm-4" v-show="$v.codepayment.$error">
            <div class="row">
            <small class="sml-red" v-if="!$v.codepayment.required">Midas payment type site is required</small>
            </div> 
        </div>
</div>




<hr >
<div class="row " >
    <div class="col-sm-6" >
            <button v-on:click="SavePopup" :disabled="disableSave" type="button" class="btn BtnSave  btn-sml"><i :class="saveIcon"></i> {{btnName}} </button>
    </div>
    <div class="col-sm-6">
        <button v-on:click="ClosePopup" type="button" class="btn BtnClose btn-sml float-right"><i class="fas fa-times"></i> Close Form </button>
    </div>
</div>

</form>
</div>

</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import Datepicker from 'vuejs-datepicker';
import moment from 'moment';
import Vuelidate from 'vuelidate'
import { helpers } from 'vuelidate/lib/validators'
const isPhone = helpers.regex('alphaNum', /\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/)
const isPostal = helpers.regex('alphaNum', /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/)
const alphaNumAndDotValid = helpers.regex('alphaNumAndDot', /^[a-z\d.]*$/i);
//^(?=.*[0-9])(?=.*[a-z])([a-z0-9_-]+)$

//const alphaNum = helpers.regex('alphaNum', /^(?=.*[0-9])(?=.*[a-z])([a-z0-9 _-]+)$/);
const alphaNum = helpers.regex('alphaNum', /^(?=.*[0-9])(?=.*[A-Za-z])([A-Za-z0-9 _-]+)$/);
Vue.use(Vuelidate)
import { required, minLength, maxLength, between,withParams,email,numeric,requiredIf} from 'vuelidate/lib/validators'
import { emailFormatter } from '@/Common/Default/EmailFormatter'
import { notEqual } from 'assert'; 
export default {
    props:{
        UserData:'',
        mode:''
    },
  data: function(){
    return{
        pointerevent:'pointer-events", "auto',
        form: {
        address1: "",
        address3: ""
        },
        pending: 'false',
        PendingValues: [
        { label: "Yes", value: 'true' },
        { label: "NO", value: 'false' },
        ],
        saveIcon:'fas fa-plus',
        btnName: 'Add Clinic',
        clinicname:'',
        clinicno:'',
        servicetype:'',
        clinicmanager:'',
        businessphoneno:'',
        emailaddress:'',
        address1:'',
        address2:'',
        address3:'',
        businessfax:'', 
        provincecode:'',
        postalcode:'',
        effectivedate:'',
        expirydate:'',
        midassupplierno:'',
        midassuppliersite:'',
        codepayment:'',
        succeeded:true,
        showModal:false,
        dateFormat:'',
        Prov:['AB', 'BC', 'MB', 'NB', 'NL', 'NT', 'NS', 'NU', 'ON', 'PE', 'QC', 'SK', 'YT'],
        //PayType:[['id']='E',['text']='Electronic'],[['id']='C',['text']='Cheque']]
        PayType:'',
        datapickClass:"form-control form-control-xs my-0",
        ServiceTypes:[],
        succeeded:true,
        showModal:false,
        Msg:'',
        EditMode:'',
        disableSave:false,
        isExpired:false,
        iseffective:false,

    }   
  },

  watch:{

    pending: function(){
          
          if(this.pending === 'false')
          {
            console.log('at false')
          }
          else if(this.pending === 'true')
          {
            this.effectivedate ='9999/12/30';
            console.log('at true')
          }
      },

    // pending: {
    //   handler: function () {
    //       console.log('caught!');
    //   },
    //   deep: true
    // },
    },
created: function(){
      this.EditMode = this.mode;
      if(this.EditMode  == 'Edit')
      {
          this.btnName = 'Edit Clinic';
          this.saveIcon = 'far fa-edit'; 
      }
      console.log('status = ' + this.UserData.status)
      if(this.UserData.pending == true)
      { 
         this.pending= 'true';
         this.PendingValues= [
            { label: "Yes", value: 'true',disabled:false },
            { label: "NO", value: 'false',disabled:false },
            ]
      }
      else if(this.UserData.pending == false) 
      {
            this.PendingValues= [
            { label: "Yes", value: 'true',disabled:true },
            { label: "NO", value: 'false',disabled:false },
            ]
            this.pending= 'false';
      }
      
      this.dateFormat = this.$store.getters.GetDateFormat; 
      this.clinicname = this.UserData.clinicname == undefined?'':this.UserData.clinicname;
      this.clinicno = this.UserData.clinicno==undefined?'':this.UserData.clinicno;
      this.clinicno = ('00000' + this.clinicno.toString()).substring(this.clinicno.toString().length);
      this.name = this.UserData.name;
      this.clinicmanager = this.UserData.clinicmanager;
      this.businessphoneno = this.UserData.businessphoneno;
      
      this.emailaddress = this.UserData.emailaddress== undefined?'':this.UserData.emailaddress;
      this.address1 = this.UserData.address1;
      console.log(' address 1 = ' + this.UserData.address1)
      this.address2 = this.UserData.address2;
        this.address3 = this.UserData.address3 == undefined?'':this.UserData.address3;
        this.businessfax = this.UserData.businessfax==undefined?'':this.UserData.businessfax=='--'?'':this.UserData.businessfax;

      this.provincecode = this.UserData.provincecode == undefined?'SK':this.UserData.provincecode;
      this.postalcode = this.UserData.postalcode;
                  
        this.effectivedate = moment(this.UserData.effectivedate==undefined?new Date():this.UserData.effectivedate, "YYYY-MM-DD").format('YYYY/MM/DD');
        this.expirydate = moment(this.UserData.expirydate==undefined?'9999/12/31':this.UserData.expirydate, "YYYY-MM-DD").format('YYYY/MM/DD');
        this.isExpired = (moment(this.expirydate)).toISOString() <= moment().startOf('day').toISOString();
        this.iseffective = (moment(this.effectivedate)).toISOString() <= moment().startOf('day').toISOString();
        if (this.iseffective && this.EditMode != "Add")
        {
            this.PendingValues= [
            { label: "Yes", value: 'true',disabled:true },
            { label: "NO", value: 'false',disabled:true },
            ]
        }
        
 

    console.log(' pointer event ' + this.pointerevent)
      console.log('midas sup no = ' +this.UserData.midassupplierno) 
      this.midassupplierno = this.UserData.midassupplierno;
      console.log('midas sup no after = ' +this.midassupplierno) 
      this.midassuppliersite = this.UserData.midassuppliersite;

      this.PayType = [{id:'E', text:'Electronic Remittance'},{id:'C', text:'Cheque'},{id:'D', text:'Direct Deposit'}];
     
      this.codepayment = this.PayType.find(x=>x.id === (this.UserData.codepayment == undefined?'E':this.UserData.codepayment));
    
        
      var vm = this;

        axios.get('SaskHealthApi/Codes/GetServicesComboWithoutDPEBB?_='+Date.now(), { headers: { 'Authorization': 'Bearer ' + localStorage.access_token }})
        .then(function (response) {
            vm.ServiceTypes=response.data.items;
            vm.servicetype = vm.ServiceTypes.find(x=>x.text === vm.UserData.name);
            })
        .catch(function (er) {

            console.log(er)
            
            });

      
      

  },



  components:{
      Datepicker
  },
  computed: {
    rules () {
      return this.pending === 'true' 
        ? { address1: { required } } 
        : { address3: { required } }
    }
  },
methods: {
    pendingChange(){
        //  if (this.pending==='true'){
        //       this.effectivedate ='9999/12/30';           
        //  }
        //  else
        //  {
             
        //  }  
    },
  ClosePopup: function() {     
      this.$root.$emit('bv::hide::modal', 'editModal', '#btnShow') 
         this.$v.$reset();
    },
    SavePopup: function(){ 
        console.log(this.$v)
        this.$v.$touch();

      if (!this.$v.$invalid){
           this.disableSave = true;
            console.log(' email ' +this.UserData.emailaddress)
            var offset = (new Date()).getTimezoneOffset() / 60;

            var effDate =  moment(this.effectivedate).startOf('day').subtract('hours',offset);
            var expDate = moment(this.expirydate).startOf('day').subtract('hours',offset)
            console.log('postal code ' + this.postalcode)
            if (this.postalcode !== null && this.postalcode !== undefined && this.postalcode !== '')
             this.postalcode = this.postalcode.replace(/[^0-9a-z]/gi,'')
            //this.postalcode =  this.postalcode;
             console.log('postal code  after' + this.postalcode)
            this.businessphoneno = (this.businessphoneno != null && this.businessphoneno != undefined && this.businessphoneno != '') ? (this.businessphoneno.replace(/[^0-9]/gi,'')).slice((-10)) : this.businessphoneno;
            this.businessfax = (this.businessfax != null && this.businessfax != undefined && this.businessfax != '') ?(this.businessfax.replace(/[^0-9]/gi,'')).slice((-10)) :this.businessfax;
            
            var vm = this;

            var url = "SaskHealthApi/Host/PostEditClinics/"
           
             var params = {
                "_": Date.now(), 
                "clinicno": vm.clinicno,
                "servicetype" : vm.servicetype.type,
                "servicetypeid":vm.servicetype.id,
                "effectivedate": effDate,
                "expiry": expDate,
                "clinicname" : vm.clinicname,
                "clinicmanager" : vm.clinicmanager,
                "address1" : vm.address1,
                "address2" : vm.address2,
                "address3" : vm.address3,
                "provincecode" : vm.provincecode,
                "postalcode" : vm.postalcode,
                "businessphoneno" : vm.businessphoneno,
                "businessfax" : vm.businessfax,
                "email":vm.emailaddress,
                "midasSupplierno" : vm.midassupplierno,
                "midassuppliersite" : vm.midassuppliersite,
                "codepayment" : vm.codepayment.id,
                "mode": vm.EditMode == "Add"?'A':'U',
                "IsPendingNow" : vm.pending === 'true' ? true :false,
                //"AlreadyPending" : vm.UserData.pending
                } 

                console.log('prams  =  ' + params)
                axios({
                    method: 'post',
                    url: url,
                    headers: { 'Authorization': 'Bearer ' + vm.$store.getters.GetAccessToken },
                    data: params
                    }).then(function (response) {
                        console.log(response)
                                vm.succeeded = true;
                                 vm.Msg= "Clinic Number: " + vm.clinicno + ". " + response.data;                        
                                vm.showModal=true;
                })
                .catch(function (er) { 
                  if(er.response.status ==400)
                  {
                     vm.disableSave = false;
                     vm.succeeded = false;
                     vm.Msg="Warning: Save UnSuccessfully For Clinic Number " +  vm.clinicno+" ( " + er.response.data.message + ").";  
                     vm.showModal=true;
                  }
                  else if(er.response.status == 500)
                  {
                    vm.disableSave = false;
                    vm.succeeded = false;  
                    vm.showModal=true;                      
                    // if(er.response.data.message !=null)
                    // vm.Msg = er.response.data.message;
                    // else
                    vm.Msg = "Network Related Error ! Please contact system administrator." 
                  }                 
                }).then(function () {

                }); 
      }
    },
    clinicExit: function(){
        this.showModal=false;
          if(this.succeeded){
           this.$emit('clinicUpdated');
    }
    }
},

// validations(){
// return {
//       form: this.rules
//     }
// },
  validations(){
    return {
        clinicname:{
            required
        },
        clinicno:{
            required,
            numeric,
            minLength:minLength(5)
        },
        servicetype:{
            required
        },
        // clinicmanager:{
        //         required,
        // },
        businessphoneno:{
            required: requiredIf(function () {
                return this.pending ==='false'
            }),
            isPhone
        },
        emailaddress:{
           // required,
            //email
            email: (val) => email(emailFormatter(val))
        },
        address1:{
            //required : (val) => (this.pending =='true' ? true  : false)
            //required
            required: requiredIf(function () {
                return this.pending ==='false'
            }),
        },
            address3:{
            required: requiredIf(function () {
                return this.pending ==='false'
            }),
        },
        businessfax:{
            isPhone
        },
            provincecode:{
            required: requiredIf(function () {
                return this.pending ==='false'
            }),
        },
        postalcode:{
            required: requiredIf(function () {
                return this.pending ==='false'
            }),
            isPostal
        },
        
        effectivedate:{
            required
        },
        expirydate:{
            required,
            minValue1: value => (moment(this.expirydate)).toISOString() >=  moment().startOf('day').toISOString(), 
            minValue2: value => moment(this.expirydate).toISOString() > (moment(this.effectivedate)).toISOString()
        },
               
        midassupplierno:{
            required: requiredIf(function () {
                return this.pending ==='false'
            }),
            numeric
        },
        midassuppliersite:{
            required: requiredIf(function () {
                return this.pending ==='false'
            }),
            alphaNum
        },
        codepayment:{
            required: requiredIf(function () {
                return this.pending ==='false'
            }),
        }
    }
  }
}
</script>

<style>
.disable { 
  pointer-events: none; 
}
</style>
